// extracted by mini-css-extract-plugin
module.exports = {"boxContain":"styles_boxContain__3gie0","colorContainer":"styles_colorContainer__2nYgQ"};